/** All built-in and custom scalars, mapped to their actual values */

let CyclePeriod;
(function (CyclePeriod) {
  CyclePeriod["D"] = "d";
  CyclePeriod["Hr"] = "hr";
  CyclePeriod["Mo"] = "mo";
  CyclePeriod["Wk"] = "wk";
  CyclePeriod["Yr"] = "yr";
})(CyclePeriod || (CyclePeriod = {}));
let Day;
(function (Day) {
  Day["Friday"] = "Friday";
  Day["Monday"] = "Monday";
  Day["Saturday"] = "Saturday";
  Day["Sunday"] = "Sunday";
  Day["Thursday"] = "Thursday";
  Day["Tuesday"] = "Tuesday";
  Day["Wednesday"] = "Wednesday";
})(Day || (Day = {}));
let Direction;
(function (Direction) {
  Direction["Asc"] = "asc";
  Direction["Desc"] = "desc";
})(Direction || (Direction = {}));
let DiscountType;
(function (DiscountType) {
  DiscountType["Fixed"] = "Fixed";
  DiscountType["Percentage"] = "Percentage";
})(DiscountType || (DiscountType = {}));
let FilterOperation;
(function (FilterOperation) {
  FilterOperation["Eq"] = "eq";
  FilterOperation["Gt"] = "gt";
  FilterOperation["Gte"] = "gte";
  FilterOperation["In"] = "in";
  FilterOperation["Lt"] = "lt";
  FilterOperation["Lte"] = "lte";
  FilterOperation["Neq"] = "neq";
  FilterOperation["Nin"] = "nin";
})(FilterOperation || (FilterOperation = {}));
let Method;
(function (Method) {
  Method["Delete"] = "DELETE";
  Method["Get"] = "GET";
  Method["Patch"] = "PATCH";
  Method["Post"] = "POST";
})(Method || (Method = {}));
let SortingFunction;
(function (SortingFunction) {
  SortingFunction["Default"] = "default";
  SortingFunction["Locale"] = "locale";
})(SortingFunction || (SortingFunction = {}));

const api_url = 'https://sentinel.tutoruu.com/';
async function fetchGQL(query, variables = null, headers = {}) {
  const res = await fetch(api_url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...headers
    },
    body: JSON.stringify({
      query,
      variables
    })
  });
  const {
    data,
    errors
  } = await res.json();
  if (Array.isArray(errors)) errors.forEach(error => console.log(error));
  return data;
}
async function Query(name, query) {
  return await fetchGQL( /* GraphQL */`query ${name} {
              ${query}
      }`);
}
async function Mutation(name, mutation) {
  return await fetchGQL( /* GraphQL */`mutation ${name} {
              ${mutation}
      }`);
}
async function getUserByEmail(query, email) {
  return (await fetchGQL( /* GraphQL */`query UserByEmailQuery($email: String!) {
        userByEmail(email: $email) {
            ${query}
        }
    }`, {
    email
  })).userByEmail;
}
async function getUserByUsername(query, username) {
  return (await fetchGQL( /* GraphQL */`query UserByUsernameQuery($username: String!) {
        userByUsername(username: $username) {
            ${query}
        }
    }`, {
    username
  })).userByUsername;
}
async function getUser(query, _id) {
  return (await fetchGQL( /* GraphQL */`query UserQuery($_id: String!) {
        user(_id: $_id) {
            ${query}
        }
    }`, {
    _id
  })).user;
}
async function getUsers(query, input) {
  return (await fetchGQL( /* GraphQL */`query UsersQuery($input: QueryOptions) {
        users(input: $input) {
            ${query}
        }
    }`, {
    input
  })).users;
}
async function getUniversity(query, _id) {
  return (await fetchGQL( /* GraphQL */`query UniversityQuery($_id: String) {
        university(_id: $_id) {
            ${query}
        }
    }`, {
    _id
  })).university;
}
async function getUniversityByAbbrev(query, abbrev) {
  return (await fetchGQL( /* GraphQL */`query UniversityByAbbrevQuery($abbrev: String) {
        universityByAbbrev(abbrev: $abbrev) {
            ${query}
        }
    }`, {
    abbrev
  })).universityByAbbrev;
}
async function getUniversities(query, input) {
  return (await fetchGQL( /* GraphQL */`query UniversitiesQuery($input: QueryOptions) {
        universities(input: $input) {
            ${query}
        }
    }`, {
    input
  })).universities;
}
async function getClasses(query, input) {
  return (await fetchGQL( /* GraphQL */`query ClassesQuery($input: QueryOptions) {
        classes(input: $input) {
            ${query}
        }
    }`, {
    input
  })).classes;
}
async function getClass(query, desc) {
  return (await fetchGQL( /* GraphQL */`query ClassQuery($desc: String!) {
        class(desc: $desc) {
            ${query}
        }
    }`, {
    desc
  })).class;
}
async function getClassById(query, id) {
  return (await fetchGQL( /* GraphQL */`query ClassByIdQuery($id: String!) {
        classById(id: $id) {
            ${query}
        }
    }`, {
    id
  })).classById;
}
async function getClassesInUniversity(query, university_abbrev, input) {
  return (await fetchGQL( /* GraphQL */`query ClassesInUniversityQuery($university_abbrev: String!, $input: QueryOptions!) {
        classesInUniversity(university_abbrev: $university_abbrev, input: $input) {
            ${query}
        }
    }`, {
    university_abbrev,
    input
  })).classesInUniversity;
}
async function getClassesRequested(query, input) {
  return (await fetchGQL( /* GraphQL */`query ClassesRequestedQuery($input: QueryOptions) {
        classesRequested(input: $input) {
            ${query}
        }
    }`, {
    input
  })).classesRequested;
}
async function getClassesInMajor(query, major, university_abbrev) {
  return (await fetchGQL( /* GraphQL */`query ClassesInMajorQuery($major: String!, $university_abbrev: String!) {
        classesInMajor(major: $major, university_abbrev: $university_abbrev) {
            ${query}
        }
    }`, {
    major,
    university_abbrev
  })).classesInMajor;
}
async function getTutor(query, id) {
  return (await fetchGQL( /* GraphQL */`query TutorQuery($id: ID!) {
        tutor(id: $id) {
            ${query}
        }
    }`, {
    id
  })).tutor;
}
async function getTutorByUsername(query, username) {
  return (await fetchGQL( /* GraphQL */`query TutorByUsernameQuery($username: String!) {
        tutorByUsername(username: $username) {
            ${query}
        }
    }`, {
    username
  })).tutorByUsername;
}
async function getTutors(query, input) {
  return (await fetchGQL( /* GraphQL */`query TutorsQuery($input: QueryOptions) {
        tutors(input: $input) {
            ${query}
        }
    }`, {
    input
  })).tutors;
}
async function getSession(query, id) {
  return (await fetchGQL( /* GraphQL */`query SessionQuery($id: ID!) {
        session(id: $id) {
            ${query}
        }
    }`, {
    id
  })).session;
}
async function getSessions(query, input) {
  return (await fetchGQL( /* GraphQL */`query SessionsQuery($input: QueryOptions) {
        sessions(input: $input) {
            ${query}
        }
    }`, {
    input
  })).sessions;
}
async function getCourse(query, course_id) {
  return (await fetchGQL( /* GraphQL */`query CourseQuery($course_id: ID!) {
        course(course_id: $course_id) {
            ${query}
        }
    }`, {
    course_id
  })).course;
}
async function getCourses(query, input) {
  return (await fetchGQL( /* GraphQL */`query CoursesQuery($input: QueryOptions) {
        courses(input: $input) {
            ${query}
        }
    }`, {
    input
  })).courses;
}
async function getCourseSearch(query, input) {
  return (await fetchGQL( /* GraphQL */`query CourseSearchQuery($input: CourseSearchInput!) {
        courseSearch(input: $input) {
            ${query}
        }
    }`, {
    input
  })).courseSearch;
}
async function getNotification(query, notification_id) {
  return (await fetchGQL( /* GraphQL */`query NotificationQuery($notification_id: ID!) {
        notification(notification_id: $notification_id) {
            ${query}
        }
    }`, {
    notification_id
  })).notification;
}
async function getNotifications(query, input) {
  return (await fetchGQL( /* GraphQL */`query NotificationsQuery($input: QueryOptions) {
        notifications(input: $input) {
            ${query}
        }
    }`, {
    input
  })).notifications;
}
async function getApplication(query, application_id) {
  return (await fetchGQL( /* GraphQL */`query ApplicationQuery($application_id: ID!) {
        application(application_id: $application_id) {
            ${query}
        }
    }`, {
    application_id
  })).application;
}
async function getApplications(query, input) {
  return (await fetchGQL( /* GraphQL */`query ApplicationsQuery($input: QueryOptions) {
        applications(input: $input) {
            ${query}
        }
    }`, {
    input
  })).applications;
}
async function getCard(query, number) {
  return (await fetchGQL( /* GraphQL */`query CardQuery($number: String!) {
        card(number: $number) {
            ${query}
        }
    }`, {
    number
  })).card;
}
async function getVendorById(query, vendor_id) {
  return (await fetchGQL( /* GraphQL */`query VendorByIdQuery($vendor_id: ID!) {
        vendorById(vendor_id: $vendor_id) {
            ${query}
        }
    }`, {
    vendor_id
  })).vendorById;
}
async function getVendors(query) {
  return (await fetchGQL( /* GraphQL */`query VendorsQuery {
        vendors {
            ${query}
        }
    }`, {})).vendors;
}
async function getDiscounts(query) {
  return (await fetchGQL( /* GraphQL */`query DiscountsQuery {
        discounts {
            ${query}
        }
    }`, {})).discounts;
}
async function getDiscountById(query, discount_id) {
  return (await fetchGQL( /* GraphQL */`query DiscountByIdQuery($discount_id: ID!) {
        discountById(discount_id: $discount_id) {
            ${query}
        }
    }`, {
    discount_id
  })).discountById;
}
async function getMetric(query, name, cycle_period, cycle_multiple) {
  return (await fetchGQL( /* GraphQL */`query MetricQuery($name: String!, $cycle_period: CyclePeriod, $cycle_multiple: Int) {
        metric(name: $name, cycle_period: $cycle_period, cycle_multiple: $cycle_multiple) {
            ${query}
        }
    }`, {
    name,
    cycle_period,
    cycle_multiple
  })).metric;
}
async function getMajors(query) {
  return (await fetchGQL( /* GraphQL */`query MajorsQuery {
        majors {
            ${query}
        }
    }`, {})).majors;
}
async function getMajorsByUniversityAbbrev(query, university) {
  return (await fetchGQL( /* GraphQL */`query MajorsByUniversityAbbrevQuery($university: String!) {
        majorsByUniversityAbbrev(university: $university) {
            ${query}
        }
    }`, {
    university
  })).majorsByUniversityAbbrev;
}
async function getSubjects(query) {
  return (await fetchGQL( /* GraphQL */`query SubjectsQuery {
        subjects {
            ${query}
        }
    }`, {})).subjects;
}
async function getBooking(query, id) {
  return (await fetchGQL( /* GraphQL */`query BookingQuery($id: ID!) {
        booking(id: $id) {
            ${query}
        }
    }`, {
    id
  })).booking;
}
async function getBookingByOrderId(query, orderId) {
  return (await fetchGQL( /* GraphQL */`query BookingByOrderIdQuery($orderId: ID!) {
        bookingByOrderId(orderId: $orderId) {
            ${query}
        }
    }`, {
    orderId
  })).bookingByOrderId;
}
async function getAmbassadorPickups(query, token) {
  return (await fetchGQL( /* GraphQL */`query AmbassadorPickupsQuery {
        ambassadorPickups {
            ${query}
        }
    }`, {}, {
    authorization: 'Bearer ' + (token || (typeof window !== 'undefined' ? localStorage.getItem('token') : ''))
  })).ambassadorPickups;
}
async function getPickups(query, token) {
  return (await fetchGQL( /* GraphQL */`query PickupsQuery {
        pickups {
            ${query}
        }
    }`, {}, {
    authorization: 'Bearer ' + (token || (typeof window !== 'undefined' ? localStorage.getItem('token') : ''))
  })).pickups;
}
async function getPickupAreas(query, token) {
  return (await fetchGQL( /* GraphQL */`query PickupAreasQuery {
        pickupAreas {
            ${query}
        }
    }`, {}, {
    authorization: 'Bearer ' + (token || (typeof window !== 'undefined' ? localStorage.getItem('token') : ''))
  })).pickupAreas;
}
async function getUserProfile(query, token) {
  return (await fetchGQL( /* GraphQL */`query UserProfileQuery {
        userProfile {
            ${query}
        }
    }`, {}, {
    authorization: 'Bearer ' + (token || (typeof window !== 'undefined' ? localStorage.getItem('token') : ''))
  })).userProfile;
}
async function getCalendarConnectionUrl(query, token) {
  return (await fetchGQL( /* GraphQL */`query CalendarConnectionUrlQuery {
        calendarConnectionUrl {
            ${query}
        }
    }`, {}, {
    authorization: 'Bearer ' + (token || (typeof window !== 'undefined' ? localStorage.getItem('token') : ''))
  })).calendarConnectionUrl;
}
async function getUniversityLookup(query, token) {
  return (await fetchGQL( /* GraphQL */`query UniversityLookupQuery {
        universityLookup {
            ${query}
        }
    }`, {}, {
    authorization: 'Bearer ' + (token || (typeof window !== 'undefined' ? localStorage.getItem('token') : ''))
  })).universityLookup;
}
async function getCategories(query, token) {
  return (await fetchGQL( /* GraphQL */`query CategoriesQuery {
        categories {
            ${query}
        }
    }`, {}, {
    authorization: 'Bearer ' + (token || (typeof window !== 'undefined' ? localStorage.getItem('token') : ''))
  })).categories;
}
async function getTags(query, token) {
  return (await fetchGQL( /* GraphQL */`query TagsQuery {
        tags {
            ${query}
        }
    }`, {}, {
    authorization: 'Bearer ' + (token || (typeof window !== 'undefined' ? localStorage.getItem('token') : ''))
  })).tags;
}
async function getPostsByUniversityId(query, university_id, token) {
  return (await fetchGQL( /* GraphQL */`query PostsByUniversityIdQuery($university_id: Int!) {
        PostsByUniversityId(university_id: $university_id) {
            ${query}
        }
    }`, {
    university_id
  }, {
    authorization: 'Bearer ' + (token || (typeof window !== 'undefined' ? localStorage.getItem('token') : ''))
  })).PostsByUniversityId;
}
async function getFeed(query, university_id, userId, token) {
  return (await fetchGQL( /* GraphQL */`query FeedQuery($university_id: Int!, $userId: Int!) {
        Feed(university_id: $university_id, userId: $userId) {
            ${query}
        }
    }`, {
    university_id,
    userId
  }, {
    authorization: 'Bearer ' + (token || (typeof window !== 'undefined' ? localStorage.getItem('token') : ''))
  })).Feed;
}
async function getPostByCategory(query, category_id, university_id, token) {
  return (await fetchGQL( /* GraphQL */`query PostByCategoryQuery($category_id: Int!, $university_id: Int!) {
        PostByCategory(category_id: $category_id, university_id: $university_id) {
            ${query}
        }
    }`, {
    category_id,
    university_id
  }, {
    authorization: 'Bearer ' + (token || (typeof window !== 'undefined' ? localStorage.getItem('token') : ''))
  })).PostByCategory;
}
async function getPost(query, post_id, token) {
  return (await fetchGQL( /* GraphQL */`query PostQuery($post_id: Int!) {
        Post(post_id: $post_id) {
            ${query}
        }
    }`, {
    post_id
  }, {
    authorization: 'Bearer ' + (token || (typeof window !== 'undefined' ? localStorage.getItem('token') : ''))
  })).Post;
}
async function getPostByTag(query, textSerach, token) {
  return (await fetchGQL( /* GraphQL */`query PostByTagQuery($textSerach: String!) {
        PostByTag(textSerach: $textSerach) {
            ${query}
        }
    }`, {
    textSerach
  }, {
    authorization: 'Bearer ' + (token || (typeof window !== 'undefined' ? localStorage.getItem('token') : ''))
  })).PostByTag;
}
async function getUserPosts(query, token) {
  return (await fetchGQL( /* GraphQL */`query UserPostsQuery {
        UserPosts {
            ${query}
        }
    }`, {}, {
    authorization: 'Bearer ' + (token || (typeof window !== 'undefined' ? localStorage.getItem('token') : ''))
  })).UserPosts;
}
async function getSavedPosts(query, token) {
  return (await fetchGQL( /* GraphQL */`query SavedPostsQuery {
        SavedPosts {
            ${query}
        }
    }`, {}, {
    authorization: 'Bearer ' + (token || (typeof window !== 'undefined' ? localStorage.getItem('token') : ''))
  })).SavedPosts;
}
async function getQuestsWithProgress(query, user_id, token) {
  return (await fetchGQL( /* GraphQL */`query QuestsWithProgressQuery($user_id: String!) {
        questsWithProgress(user_id: $user_id) {
            ${query}
        }
    }`, {
    user_id
  }, {
    authorization: 'Bearer ' + (token || (typeof window !== 'undefined' ? localStorage.getItem('token') : ''))
  })).questsWithProgress;
}
async function getTask(query, identifier) {
  return (await fetchGQL( /* GraphQL */`query TaskQuery($identifier: String!) {
        task(identifier: $identifier) {
            ${query}
        }
    }`, {
    identifier
  })).task;
}
async function getTaskById(query, id) {
  return (await fetchGQL( /* GraphQL */`query TaskByIdQuery($id: String!) {
        taskById(id: $id) {
            ${query}
        }
    }`, {
    id
  })).taskById;
}
async function getTasks(query) {
  return (await fetchGQL( /* GraphQL */`query TasksQuery {
        tasks {
            ${query}
        }
    }`, {})).tasks;
}
async function createUser(query, input) {
  return (await fetchGQL( /* GraphQL */`mutation CreateUserMutation($input: CreateUserInput!) {
        createUser(input: $input) {
            ${query}
        }
    }`, {
    input
  })).createUser;
}
async function updateUser(query, _id, input) {
  return (await fetchGQL( /* GraphQL */`mutation UpdateUserMutation($_id: String!, $input: UpdateUserInput!) {
        updateUser(_id: $_id, input: $input) {
            ${query}
        }
    }`, {
    _id,
    input
  })).updateUser;
}
async function deleteUser(query, _id) {
  return (await fetchGQL( /* GraphQL */`mutation DeleteUserMutation($_id: String!) {
        deleteUser(_id: $_id) {
            ${query}
        }
    }`, {
    _id
  })).deleteUser;
}
async function createUserWithSession(query, session, user) {
  return (await fetchGQL( /* GraphQL */`mutation CreateUserWithSessionMutation($session: CreateSessionRequestInput!, $user: CreateUserInput!) {
        createUserWithSession(session: $session, user: $user) {
            ${query}
        }
    }`, {
    session,
    user
  })).createUserWithSession;
}
async function createUniversity(query, input) {
  return (await fetchGQL( /* GraphQL */`mutation CreateUniversityMutation($input: CreateUniversityInput!) {
        createUniversity(input: $input) {
            ${query}
        }
    }`, {
    input
  })).createUniversity;
}
async function updateUniversity(query, _id, input) {
  return (await fetchGQL( /* GraphQL */`mutation UpdateUniversityMutation($_id: String!, $input: UpdateUniversityInput!) {
        updateUniversity(_id: $_id, input: $input) {
            ${query}
        }
    }`, {
    _id,
    input
  })).updateUniversity;
}
async function createClass(query, data, university_id) {
  return (await fetchGQL( /* GraphQL */`mutation CreateClassMutation($data: CreateClassInput!, $university_id: String!) {
        createClass(data: $data, university_id: $university_id) {
            ${query}
        }
    }`, {
    data,
    university_id
  })).createClass;
}
async function joinClass(query, class_id, student_id) {
  return (await fetchGQL( /* GraphQL */`mutation JoinClassMutation($class_id: String!, $student_id: String!) {
        joinClass(class_id: $class_id, student_id: $student_id) {
            ${query}
        }
    }`, {
    class_id,
    student_id
  })).joinClass;
}
async function deleteClass(query, id) {
  return (await fetchGQL( /* GraphQL */`mutation DeleteClassMutation($id: String!) {
        deleteClass(id: $id) {
            ${query}
        }
    }`, {
    id
  })).deleteClass;
}
async function updateClass(query, input) {
  return (await fetchGQL( /* GraphQL */`mutation UpdateClassMutation($input: UpdateClassInput) {
        updateClass(input: $input) {
            ${query}
        }
    }`, {
    input
  })).updateClass;
}
async function fulfillRequests(query, id) {
  return (await fetchGQL( /* GraphQL */`mutation FulfillRequestsMutation($id: ID!) {
        fulfillRequests(id: $id) {
            ${query}
        }
    }`, {
    id
  })).fulfillRequests;
}
async function createTutor(query, user_id, application_id) {
  return (await fetchGQL( /* GraphQL */`mutation CreateTutorMutation($user_id: String, $application_id: String) {
        createTutor(user_id: $user_id, application_id: $application_id) {
            ${query}
        }
    }`, {
    user_id,
    application_id
  })).createTutor;
}
async function updateTutor(query, tutor_id, input) {
  return (await fetchGQL( /* GraphQL */`mutation UpdateTutorMutation($tutor_id: String!, $input: UpdateTutorInput!) {
        updateTutor(tutor_id: $tutor_id, input: $input) {
            ${query}
        }
    }`, {
    tutor_id,
    input
  })).updateTutor;
}
async function createTutorWithoutApplication(query, input) {
  return (await fetchGQL( /* GraphQL */`mutation CreateTutorWithoutApplicationMutation($input: CreateTutorWithoutApplicationInput!) {
        createTutorWithoutApplication(input: $input) {
            ${query}
        }
    }`, {
    input
  })).createTutorWithoutApplication;
}
async function createSessionRequest(query, user_id, input) {
  return (await fetchGQL( /* GraphQL */`mutation CreateSessionRequestMutation($user_id: ID!, $input: CreateSessionRequestInput!) {
        createSessionRequest(user_id: $user_id, input: $input) {
            ${query}
        }
    }`, {
    user_id,
    input
  })).createSessionRequest;
}
async function updateSession(query, session_id, input) {
  return (await fetchGQL( /* GraphQL */`mutation UpdateSessionMutation($session_id: ID!, $input: UpdateSessionInput!) {
        updateSession(session_id: $session_id, input: $input) {
            ${query}
        }
    }`, {
    session_id,
    input
  })).updateSession;
}
async function acceptSession(query, tutor_id, session_id) {
  return (await fetchGQL( /* GraphQL */`mutation AcceptSessionMutation($tutor_id: ID!, $session_id: ID!) {
        acceptSession(tutor_id: $tutor_id, session_id: $session_id) {
            ${query}
        }
    }`, {
    tutor_id,
    session_id
  })).acceptSession;
}
async function rejectSession(query, tutor_id, session_id) {
  return (await fetchGQL( /* GraphQL */`mutation RejectSessionMutation($tutor_id: ID!, $session_id: ID!) {
        rejectSession(tutor_id: $tutor_id, session_id: $session_id) {
            ${query}
        }
    }`, {
    tutor_id,
    session_id
  })).rejectSession;
}
async function deleteSession(query, session_id) {
  return (await fetchGQL( /* GraphQL */`mutation DeleteSessionMutation($session_id: ID!) {
        deleteSession(session_id: $session_id) {
            ${query}
        }
    }`, {
    session_id
  })).deleteSession;
}
async function prebookSession(query, slot, course_id, student) {
  return (await fetchGQL( /* GraphQL */`mutation PrebookSessionMutation($slot: SlotInput!, $course_id: ID!, $student: ID!) {
        prebookSession(slot: $slot, course_id: $course_id, student: $student) {
            ${query}
        }
    }`, {
    slot,
    course_id,
    student
  })).prebookSession;
}
async function markSessionPaid(query, id) {
  return (await fetchGQL( /* GraphQL */`mutation MarkSessionPaidMutation($id: ID!) {
        markSessionPaid(id: $id) {
            ${query}
        }
    }`, {
    id
  })).markSessionPaid;
}
async function createCourse(query, tutor_id, input) {
  return (await fetchGQL( /* GraphQL */`mutation CreateCourseMutation($tutor_id: ID!, $input: CreateCourseInput!) {
        createCourse(tutor_id: $tutor_id, input: $input) {
            ${query}
        }
    }`, {
    tutor_id,
    input
  })).createCourse;
}
async function updateCourse(query, course_id, input) {
  return (await fetchGQL( /* GraphQL */`mutation UpdateCourseMutation($course_id: ID!, $input: UpdateCourseInput!) {
        updateCourse(course_id: $course_id, input: $input) {
            ${query}
        }
    }`, {
    course_id,
    input
  })).updateCourse;
}
async function deleteCourse(query, course_id) {
  return (await fetchGQL( /* GraphQL */`mutation DeleteCourseMutation($course_id: ID!) {
        deleteCourse(course_id: $course_id) {
            ${query}
        }
    }`, {
    course_id
  })).deleteCourse;
}
async function createReview(query, user_id, input) {
  return (await fetchGQL( /* GraphQL */`mutation CreateReviewMutation($user_id: ID!, $input: CreateReviewInput!) {
        createReview(user_id: $user_id, input: $input) {
            ${query}
        }
    }`, {
    user_id,
    input
  })).createReview;
}
async function createNotification(query, input) {
  return (await fetchGQL( /* GraphQL */`mutation CreateNotificationMutation($input: CreateNotificationInput!) {
        createNotification(input: $input) {
            ${query}
        }
    }`, {
    input
  })).createNotification;
}
async function readNotification(query, notification_id) {
  return (await fetchGQL( /* GraphQL */`mutation ReadNotificationMutation($notification_id: ID!) {
        readNotification(notification_id: $notification_id) {
            ${query}
        }
    }`, {
    notification_id
  })).readNotification;
}
async function deleteNotification(query, notification_id) {
  return (await fetchGQL( /* GraphQL */`mutation DeleteNotificationMutation($notification_id: ID!) {
        deleteNotification(notification_id: $notification_id) {
            ${query}
        }
    }`, {
    notification_id
  })).deleteNotification;
}
async function createTutorApplication(query, user_id) {
  return (await fetchGQL( /* GraphQL */`mutation CreateTutorApplicationMutation($user_id: ID!) {
        createTutorApplication(user_id: $user_id) {
            ${query}
        }
    }`, {
    user_id
  })).createTutorApplication;
}
async function updateApplication(query, user_id, input) {
  return (await fetchGQL( /* GraphQL */`mutation UpdateApplicationMutation($user_id: ID!, $input: UpdateApplicationInput!) {
        updateApplication(user_id: $user_id, input: $input) {
            ${query}
        }
    }`, {
    user_id,
    input
  })).updateApplication;
}
async function createApplicationCourse(query, course) {
  return (await fetchGQL( /* GraphQL */`mutation CreateApplicationCourseMutation($course: CreateApplicationCourseInput!) {
        createApplicationCourse(course: $course) {
            ${query}
        }
    }`, {
    course
  })).createApplicationCourse;
}
async function verifyCard(query, card_number, user_id) {
  return (await fetchGQL( /* GraphQL */`mutation VerifyCardMutation($card_number: String!, $user_id: ID!) {
        verifyCard(card_number: $card_number, user_id: $user_id) {
            ${query}
        }
    }`, {
    card_number,
    user_id
  })).verifyCard;
}
async function createVendor(query, input) {
  return (await fetchGQL( /* GraphQL */`mutation CreateVendorMutation($input: CreateVendorInput!) {
        createVendor(input: $input) {
            ${query}
        }
    }`, {
    input
  })).createVendor;
}
async function updateVendor(query, vendor_id, input) {
  return (await fetchGQL( /* GraphQL */`mutation UpdateVendorMutation($vendor_id: ID!, $input: UpdateVendorInput!) {
        updateVendor(vendor_id: $vendor_id, input: $input) {
            ${query}
        }
    }`, {
    vendor_id,
    input
  })).updateVendor;
}
async function deleteVendor(query, vendor_id) {
  return (await fetchGQL( /* GraphQL */`mutation DeleteVendorMutation($vendor_id: ID!) {
        deleteVendor(vendor_id: $vendor_id) {
            ${query}
        }
    }`, {
    vendor_id
  })).deleteVendor;
}
async function createDiscount(query, input) {
  return (await fetchGQL( /* GraphQL */`mutation CreateDiscountMutation($input: CreateDiscountInput!) {
        createDiscount(input: $input) {
            ${query}
        }
    }`, {
    input
  })).createDiscount;
}
async function updateDiscount(query, discount_id, input) {
  return (await fetchGQL( /* GraphQL */`mutation UpdateDiscountMutation($discount_id: ID!, $input: UpdateDiscountInput!) {
        updateDiscount(discount_id: $discount_id, input: $input) {
            ${query}
        }
    }`, {
    discount_id,
    input
  })).updateDiscount;
}
async function deleteDiscount(query, discount_id) {
  return (await fetchGQL( /* GraphQL */`mutation DeleteDiscountMutation($discount_id: ID!) {
        deleteDiscount(discount_id: $discount_id) {
            ${query}
        }
    }`, {
    discount_id
  })).deleteDiscount;
}
async function createDiscountUse(query, discount_id, user_id) {
  return (await fetchGQL( /* GraphQL */`mutation CreateDiscountUseMutation($discount_id: ID!, $user_id: ID!) {
        createDiscountUse(discount_id: $discount_id, user_id: $user_id) {
            ${query}
        }
    }`, {
    discount_id,
    user_id
  })).createDiscountUse;
}
async function createBooking(query, input) {
  return (await fetchGQL( /* GraphQL */`mutation CreateBookingMutation($input: CreateBookingInput!) {
        createBooking(input: $input) {
            ${query}
        }
    }`, {
    input
  })).createBooking;
}
async function login(query, email, password, token) {
  return (await fetchGQL( /* GraphQL */`mutation LoginMutation($email: String!, $password: String!) {
        login(email: $email, password: $password) {
            ${query}
        }
    }`, {
    email,
    password
  }, {
    authorization: 'Bearer ' + (token || (typeof window !== 'undefined' ? localStorage.getItem('token') : ''))
  })).login;
}
async function register(query, input, token) {
  return (await fetchGQL( /* GraphQL */`mutation RegisterMutation($input: UserRegistrationInput!) {
        register(input: $input) {
            ${query}
        }
    }`, {
    input
  }, {
    authorization: 'Bearer ' + (token || (typeof window !== 'undefined' ? localStorage.getItem('token') : ''))
  })).register;
}
async function ambassadorRegister(query, input, token) {
  return (await fetchGQL( /* GraphQL */`mutation AmbassadorRegisterMutation($input: UserRegistrationInput!) {
        ambassadorRegister(input: $input) {
            ${query}
        }
    }`, {
    input
  }, {
    authorization: 'Bearer ' + (token || (typeof window !== 'undefined' ? localStorage.getItem('token') : ''))
  })).ambassadorRegister;
}
async function universityLogin(query, email, password, token) {
  return (await fetchGQL( /* GraphQL */`mutation UniversityLoginMutation($email: String!, $password: String!) {
        universityLogin(email: $email, password: $password) {
            ${query}
        }
    }`, {
    email,
    password
  }, {
    authorization: 'Bearer ' + (token || (typeof window !== 'undefined' ? localStorage.getItem('token') : ''))
  })).universityLogin;
}
async function ambassadorLogin(query, email, password, token) {
  return (await fetchGQL( /* GraphQL */`mutation AmbassadorLoginMutation($email: String!, $password: String!) {
        ambassadorLogin(email: $email, password: $password) {
            ${query}
        }
    }`, {
    email,
    password
  }, {
    authorization: 'Bearer ' + (token || (typeof window !== 'undefined' ? localStorage.getItem('token') : ''))
  })).ambassadorLogin;
}
async function confirmPickup(query, orderId, token) {
  return (await fetchGQL( /* GraphQL */`mutation ConfirmPickupMutation($orderId: Int!) {
        confirmPickup(orderId: $orderId) {
            ${query}
        }
    }`, {
    orderId
  }, {
    authorization: 'Bearer ' + (token || (typeof window !== 'undefined' ? localStorage.getItem('token') : ''))
  })).confirmPickup;
}
async function ambassadorVerification(query, email, token) {
  return (await fetchGQL( /* GraphQL */`mutation AmbassadorVerificationMutation($email: String!) {
        ambassadorVerification(email: $email) {
            ${query}
        }
    }`, {
    email
  }, {
    authorization: 'Bearer ' + (token || (typeof window !== 'undefined' ? localStorage.getItem('token') : ''))
  })).ambassadorVerification;
}
async function createPickup(query, input, token) {
  return (await fetchGQL( /* GraphQL */`mutation CreatePickupMutation($input: CardPickupInput!) {
        createPickup(input: $input) {
            ${query}
        }
    }`, {
    input
  }, {
    authorization: 'Bearer ' + (token || (typeof window !== 'undefined' ? localStorage.getItem('token') : ''))
  })).createPickup;
}
async function createCalendarEvent(query, CalendarEvent, token) {
  return (await fetchGQL( /* GraphQL */`mutation CreateCalendarEventMutation($CalendarEvent: CalendarEventInput!) {
        createCalendarEvent(CalendarEvent: $CalendarEvent) {
            ${query}
        }
    }`, {
    CalendarEvent
  }, {
    authorization: 'Bearer ' + (token || (typeof window !== 'undefined' ? localStorage.getItem('token') : ''))
  })).createCalendarEvent;
}
async function updateProgress(query, user_id, quest_id, token) {
  return (await fetchGQL( /* GraphQL */`mutation UpdateProgressMutation($user_id: String!, $quest_id: String!) {
        updateProgress(user_id: $user_id, quest_id: $quest_id) {
            ${query}
        }
    }`, {
    user_id,
    quest_id
  }, {
    authorization: 'Bearer ' + (token || (typeof window !== 'undefined' ? localStorage.getItem('token') : ''))
  })).updateProgress;
}
async function sendChatEmail(query, data, token) {
  return (await fetchGQL( /* GraphQL */`mutation SendChatEmailMutation($data: ChatEmailInput!) {
        sendChatEmail(data: $data) {
            ${query}
        }
    }`, {
    data
  }, {
    authorization: 'Bearer ' + (token || (typeof window !== 'undefined' ? localStorage.getItem('token') : ''))
  })).sendChatEmail;
}
async function createTask(query, input) {
  return (await fetchGQL( /* GraphQL */`mutation CreateTaskMutation($input: CreateTaskInput!) {
        createTask(input: $input) {
            ${query}
        }
    }`, {
    input
  })).createTask;
}
async function updateTask(query, input) {
  return (await fetchGQL( /* GraphQL */`mutation UpdateTaskMutation($input: UpdateTaskInput!) {
        updateTask(input: $input) {
            ${query}
        }
    }`, {
    input
  })).updateTask;
}
async function deleteTask(query, identifier) {
  return (await fetchGQL( /* GraphQL */`mutation DeleteTaskMutation($identifier: String!) {
        deleteTask(identifier: $identifier) {
            ${query}
        }
    }`, {
    identifier
  })).deleteTask;
}

export { CyclePeriod, Day, Direction, DiscountType, FilterOperation, Method, Mutation, Query, SortingFunction, acceptSession, ambassadorLogin, ambassadorRegister, ambassadorVerification, api_url, confirmPickup, createApplicationCourse, createBooking, createCalendarEvent, createClass, createCourse, createDiscount, createDiscountUse, createNotification, createPickup, createReview, createSessionRequest, createTask, createTutor, createTutorApplication, createTutorWithoutApplication, createUniversity, createUser, createUserWithSession, createVendor, deleteClass, deleteCourse, deleteDiscount, deleteNotification, deleteSession, deleteTask, deleteUser, deleteVendor, fetchGQL, fulfillRequests, getAmbassadorPickups, getApplication, getApplications, getBooking, getBookingByOrderId, getCalendarConnectionUrl, getCard, getCategories, getClass, getClassById, getClasses, getClassesInMajor, getClassesInUniversity, getClassesRequested, getCourse, getCourseSearch, getCourses, getDiscountById, getDiscounts, getFeed, getMajors, getMajorsByUniversityAbbrev, getMetric, getNotification, getNotifications, getPickupAreas, getPickups, getPost, getPostByCategory, getPostByTag, getPostsByUniversityId, getQuestsWithProgress, getSavedPosts, getSession, getSessions, getSubjects, getTags, getTask, getTaskById, getTasks, getTutor, getTutorByUsername, getTutors, getUniversities, getUniversity, getUniversityByAbbrev, getUniversityLookup, getUser, getUserByEmail, getUserByUsername, getUserPosts, getUserProfile, getUsers, getVendorById, getVendors, joinClass, login, markSessionPaid, prebookSession, readNotification, register, rejectSession, sendChatEmail, universityLogin, updateApplication, updateClass, updateCourse, updateDiscount, updateProgress, updateSession, updateTask, updateTutor, updateUniversity, updateUser, updateVendor, verifyCard };
